import { isSamePosition } from '@wareena/game-algorithms';
export default function getPositionsWithBetterTerrain(positions, currentTerrainId, terrainPreferences, mapHexes) {
    let currentTerrainIdx = terrainPreferences.findIndex((t) => t === currentTerrainId);
    if (currentTerrainIdx < 0) {
        currentTerrainIdx = 1_000_000;
    }
    return positions.filter((position) => {
        const hex = mapHexes.find((h) => isSamePosition(h, position));
        if (!hex) {
            return false;
        }
        let terrainIdx = terrainPreferences.findIndex((t) => t === hex.terrainId);
        if (terrainIdx < 0) {
            terrainIdx = 1_000_000;
        }
        return terrainIdx < currentTerrainIdx;
    });
}
